<script lang="ts">
    import type { TopInfo } from '@shared/types/types';

    interface Props {
        infos: TopInfo[] | undefined;
        multipleSizes?: boolean;
    }

    let { infos, multipleSizes = false }: Props = $props();
</script>

{#if infos?.length && multipleSizes}
    <p class="reptile-top-info reptile-top-info--multiple-sizes">Mehrere Größen</p>
{:else if infos?.length}
    <dl class="reptile-top-info">
        {#each infos.slice(0, 3) as info (info)}
            <div class="reptile-top-info__item">
                <dd class="reptile-top-info__value">
                    {info.value}
                </dd>
                <dt class="reptile-top-info__label">{info.label}</dt>
            </div>
        {/each}
    </dl>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-top-info {
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-absolute-25;
        font: tokens.$oc-semantic-font-copy-75;

        &__item {
            @include mixins.ellipsis(nowrap);
        }

        &__label,
        &__value {
            display: inline;
        }

        &__value {
            font-weight: tokens.$oc-base-font-weight-regular;
            color: tokens.$oc-semantic-color-text-default;
        }

        &--multiple-sizes {
            /**
 *
 *
 */
            display: block;

            margin: 0;
            padding-top: 0;
            padding-bottom: 0;
            border: none;

            @include mixins.ellipsis(nowrap);
        }
    }
</style>
